import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14.5 14h4.5l2 -2v-6l-6.5 8","key":"svg-0"}],["path",{"d":"M9 19h5l-11 -13v6l6 7","key":"svg-1"}]]

/**
 * IconBrandValorant
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtdmFsb3JhbnQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE0LjUgMTRoNC41bDIgLTJ2LTZsLTYuNSA4IiAvPgogIDxwYXRoIGQ9Ik05IDE5aDVsLTExIC0xM3Y2bDYgNyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-valorant
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandValorant = createReactComponent('outline', 'brand-valorant', 'BrandValorant', __iconNode);

export default IconBrandValorant;